import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsBlockTable from "@/helpers/editor/blocks/CmsBlockTable.js";
import CmsBlockTableCell from "@/helpers/editor/blocks/CmsBlockTableCell.js";

export default class CmsBlockTableRow extends CmsBlock {
    static typeDef = {
        name: `Row|Ligne`,
        type: `table-row`,
        category: `layout`,
        glyph: `fa-table-rows`,
        isParent: true,
        hidden: true
    }

    get maxChildren() {
        return 20;
    }

    get childClasses() {
        return [CmsBlockTableCell];
    }

    get parentClasses() {
        return [CmsBlockTable];
    }

    constructor(data, page) {
        super(data, page);

        if (!data) {
            this.padding.init(0);
        }
    }

    addColumn(index) {
        this.insertChild(new CmsBlockTableCell(null, this.page), index);
    }

    syncColumnsFromTable(table) {
        if (this.children.length > table.columns.length) {
            this.children = this.children.splice(table.columns.length, this.children.length - table.columns.length);
        } else if (this.children.length < table.columns.length) {
            for (let i = this.children.length; i < table.columns.length; i++) {
                this.addChild(new CmsBlockTableCell(null, this.page));
            }
        }
    }
}
